module.exports = __webpack_public_path__ + "img/timepic_en_US.4b713a8f.png";